import { tooltip, clickOuter, marqueeNum, visible } from 'thsc-ifind-stock-f9/packages/assets/js/directives.js';
import resizeOb from 'thsc-ifind-stock-f9/packages/assets/js/directive/resizeOb.js';

export default {
  tooltip,
  clickOuter,
  marqueeNum,
  visible,
  resizeOb,
};
